"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.HB_CLICKABLE_OUTLINE_WIDTH = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _framerMotion = require("framer-motion");
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _mixins = require("../../styles/mixins");
var _excluded = ["tabIndex", "role", "onClick", "children", "id", "testIdName", "testId", "isDisabled", "withFocusState", "insetFocusState", "tag", "href"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var shouldFollowHref = function shouldFollowHref(href, e) {
  return href && (e.metaKey || e.ctrlKey);
};
var HBClickable = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'button' : _ref$role,
    onClick = _ref.onClick,
    children = _ref.children,
    id = _ref.id,
    testIdName = _ref.testIdName,
    testId = _ref.testId,
    isDisabled = _ref.isDisabled,
    _ref$withFocusState = _ref.withFocusState,
    withFocusState = _ref$withFocusState === void 0 ? true : _ref$withFocusState,
    _ref$insetFocusState = _ref.insetFocusState,
    insetFocusState = _ref$insetFocusState === void 0 ? false : _ref$insetFocusState,
    tag = _ref.tag,
    href = _ref.href,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var handleClick = function handleClick(e) {
    if (shouldFollowHref(href, e)) {
      return;
    }
    if (href && onClick) {
      e.preventDefault();
    }
    onClick === null || onClick === void 0 || onClick(e);
  };
  var clickableProps = _objectSpread(_objectSpread({}, props), {}, {
    tabIndex: tabIndex,
    role: role,
    onClick: handleClick,
    onMouseDown: props.onMouseDown,
    onKeyPress: function onKeyPress(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        handleClick(e);
      }
    }
  });
  var _props = isClickable({
    $isDisabled: isDisabled,
    onClick: onClick
  }) ? clickableProps : props;
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName || id,
    suffix: 'item',
    componentName: 'HBClickable'
  });
  return /*#__PURE__*/_react["default"].createElement(Container, (0, _extends2["default"])({}, _props, {
    ref: ref,
    "data-testid": finalTestId,
    "aria-disabled": isDisabled,
    $isDisabled: isDisabled,
    $withFocusState: withFocusState,
    $insetFocusState: insetFocusState,
    id: id,
    as: href ? 'a' : tag,
    href: href
  }), children);
});
var _default = exports["default"] = HBClickable;
var isClickable = function isClickable(_ref2) {
  var $isDisabled = _ref2.$isDisabled,
    onClick = _ref2.onClick;
  return !$isDisabled && !!onClick;
};
var HB_CLICKABLE_OUTLINE_WIDTH = exports.HB_CLICKABLE_OUTLINE_WIDTH = 5;
var Container = (0, _styledComponents["default"])(_framerMotion.motion.div).withConfig({
  displayName: "HBClickable__Container",
  componentId: "sc-1ydzdil-0"
})(["", " ", ""], function (props) {
  return isClickable(props) && (0, _styledComponents.css)(["cursor:", ";", ""], props.$isDisabled ? 'auto' : 'pointer', props.$withFocusState && (0, _mixins.focusState)({
    inset: props.$insetFocusState
  }));
}, function (props) {
  return props.href && (0, _styledComponents.css)(["text-decoration:none;outline:none;color:inherit;&:hover,&:focus,&:active{color:inherit;}"]);
});
//# sourceMappingURL=HBClickable.js.map